import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from './button';
import Icon from './icon';

const MessageBox = (props) => {
  const {
    className: classNameProp,
    onCloseClick,
    title,
    iconClosable,
    icon,
    children,
    actions,
    ...rest
  } = props;

  const {
    success,
    info,
    warning,
    danger,
  } = rest;

  const className = classnames('bvs-msg-box', classNameProp, {
    'is-success': success,
    'is-info': info,
    'is-warning': warning,
    'is-danger': danger,
  });

  return (
    <div className={className}>
      {iconClosable
        && <button className="bvs-close-button" type="button" onClick={onCloseClick} />}
      {icon
        && <Icon {...rest} />}
      {title
        && <h3 className="bvs-msg-box__title">{title}</h3>}
      <section>
        {children}
      </section>
      {actions.length > 0
        && (
        <div className="bvs-button-group">
          {actions.map((button) => <Button {...button} key={button.id} />)}
        </div>
        )}
    </div>
  );
};

MessageBox.propTypes = {
  actions: PropTypes.arrayOf(Object),
  className: PropTypes.string,
  title: PropTypes.string,
  iconClosable: PropTypes.bool,
  success: PropTypes.bool,
  info: PropTypes.bool,
  warning: PropTypes.bool,
  danger: PropTypes.bool,
  children: PropTypes.node,
  onCloseClick: PropTypes.func,
  icon: PropTypes.bool,
};

MessageBox.defaultProps = {
  actions: [],
  className: '',
  title: '',
  iconClosable: false,
  success: false,
  info: false,
  warning: false,
  danger: false,
  children: null,
  onCloseClick: () => {},
  icon: true,
};

export default MessageBox;
